import { useState } from 'react';
import { TruncateMultiline } from 'foundations-components/transitional/components/TruncateMultiline';
import I18n from 'I18n';
import styled from 'foundations-theming/utils';
import { Flex } from 'foundations-components/components/Flex';
import ColumnLayoutIcon from 'ContentEditorUI/components/shared/ColumnLayoutIcon';
import { DragSource } from 'react-dnd-compat';
import { DRAG_TYPES } from 'ContentEditorUI/utils/DragAndDropConstants';
import { WigglyAnimation } from '../add/WigglyAnimation';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MAX_CHARS = 23;
const DraggableLayoutWrapper = styled(WigglyAnimation).withConfig({
  displayName: "InpageDraggableLayout__DraggableLayoutWrapper"
})([".hs-private.hs-private.hs-private &{background:", ";border-width:", ";border-style:solid;border-color:", ";border-radius:", ";box-sizing:border-box;cursor:pointer;display:flex;flex-direction:column;height:115px;justify-content:center;padding:", ";margin-block-start:", ";margin-inline:", ";position:relative;text-align:center;width:calc(33% - 12px);}.hs-private.hs-private.hs-private &:hover{box-shadow:", ";transition:box-shadow 0.5s;}"], ({
  theme
}) => theme.color['fill-surface-default'], ({
  theme
}) => theme.borderWidth['100'], ({
  theme
}) => theme.color['border-core-default'], ({
  theme
}) => theme.borderRadius['100'], ({
  theme
}) => theme.space['300'], ({
  theme
}) => theme.space['300'], ({
  theme
}) => theme.space['100'], ({
  theme
}) => theme.boxShadow['400']);
const moduleSource = {
  beginDrag(props) {
    const dragPayload = {
      customLayoutKey: props.labelKey,
      type: 'customLayout',
      isColumn: false,
      isRow: true,
      isTopMostRow: true
    };
    props.onDragStart(dragPayload);
    return dragPayload;
  },
  endDrag(props, monitor) {
    const dropResult = monitor.getDropResult();
    const dragItem = monitor.getItem();
    if (!monitor.didDrop()) {
      props.onDragEnd(undefined, dragItem);
      return;
    }
    props.onDragEnd(dropResult, dragItem);
  }
};
const Draggable = DragSource(DRAG_TYPES.CUSTOM_SECTION, moduleSource, monitor => ({
  isDragging: monitor.isDragging()
}));
function InpageDraggableLayout({
  labelKey,
  widths,
  iconHeight,
  connectDragSource
}) {
  const [isWiggly, setIsWiggly] = useState(false);
  const toggleWiggleCard = () => {
    setIsWiggly(!isWiggly);
  };
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsxs(DraggableLayoutWrapper, {
      $animationName: "clickLayoutItem",
      $isWiggly: isWiggly,
      "data-test-id": `layout-section-tile-${labelKey}`,
      "data-transition-wrapper": "true",
      "data-hs-dragdrop": true,
      onClick: () => toggleWiggleCard(),
      onAnimationEnd: () => toggleWiggleCard()
      // @ts-ignore ts-migrate(2322) FIXME: Type 'ConnectDragSource' is not assignable to type 'RefObject<HTMLDivElement>'.
      ,
      ref: connectDragSource,
      children: [/*#__PURE__*/_jsx(Flex, {
        marginBlockStart: "300",
        marginBlockEnd: "200",
        children: /*#__PURE__*/_jsx(ColumnLayoutIcon, {
          columnWidths: widths,
          height: iconHeight
        })
      }), /*#__PURE__*/_jsx(TruncateMultiline, {
        maxChars: MAX_CHARS,
        text: I18n.text(`addSectionPanel.columnLayouts.labels.${labelKey}`)
      })]
    })
  );
}
export default Draggable(InpageDraggableLayout);